<div class="container-fluid admin-school-events-content" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='150' width='150' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    *ngIf="(router.url.includes('admin-dashboard') && isExpand) || router.url.includes('upcoming-events')"
    [fullScreen]="true"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <!-- <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='150' width='150' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    *ngIf="router.url.includes('upcoming-events')"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner> -->

  <div class="d-flex justify-content-between mt-2 header" *ngIf="!isStudent && !isTeacherView && isExpand">
    <div></div>

    <nb-card class="cursor-pointer classroom-details" *ngIf="!isAdmin && classroom">
      <nb-card-body>
        <div class="d-flex justify-content-between">
          <div class="classroom-name-content text-left">
            <h5 class="classroom-name quicksand-bold-label">
              {{ classroom?.name }}
            </h5>

            <div class="classroom-subject quicksand-bold-label">
              {{ classroom?.subject | uppercase }}
            </div>
          </div>

          <div class="d-flex" style="margin-right: -5px">
            <div class="classroom-code text-center">
              {{ classroom?.code }}
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>

    <div class="upcoming-events-container">
      <div class="ml-1 upcoming-events" *ngIf="storageService.detectMob() && isAdmin">Upcoming Special Events1</div>
      <div *ngIf="storageService.detectMob() && !isAdmin"></div>
      <div
        class="cursor-pointer close-expand-view-content btn-close-content mr-1"
        (click)="expandUpcomingEventsView(true)"
        *ngIf="storageService.detectMob()"
        [ngClass]="
          isAdmin
            ? 'close-expand-view-content-admin'
            : userStoredData.user?.role_id === 20
            ? 'close-expand-view-content-parent'
            : 'close-expand-view-content-student'
        "
      >
        <nb-icon icon="collapse" class="icon-expand-pacing-plan cursor-pointer expand-details icon-close-expand-view"></nb-icon>
      </div>

      <div class="d-flex justify-content-end w-100">
        <div class="cursor-pointer close-expand-view-content btn-close-content" (click)="expandUpcomingEventsView(true)" *ngIf="!storageService.detectMob()">
          <nb-icon icon="collapse" class="icon-close-expand-view cursor-pointer expand-details"></nb-icon>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex ml-1">
    <button
      class="add-event-expand-view quicksand-bold-label float-right text-capitalize text-white"
      *ngIf="isExpand && !isSuperAdmin && isAdmin && isMobileScreen"
      nbButton
      (click)="openEventModal()"
      title="Add Event"
    >
      <nb-icon icon="plus-outline"></nb-icon>
      Add Event
    </button>
  </div>

  <div class="row student-upcoming-events-content {{ userStoredData.user?.role_id === 20 ? '' : 'my-3' }} {{ !isAdmin ? 'p-3' : 'pb-3' }}">
    <div
      [ngClass]="{
        'col-md-12': isStudent,
        'col-md-12 col-lg-12': !isStudent,
        '': !isExpand
      }"
      class="w-100"
    >
      <div class="quicksand-bold-label header-events-content navigate-events pt-3">
        <div class="d-flex">
          <button
            mwlCalendarPreviousView
            [view]="calendarViewType"
            [(viewDate)]="viewDate"
            class="navigate-btn one"
            aria-label="Example icon button with a home icon"
            (click)="getUpcomingEvents(true)"
            [disabled]="isCalendarStart"
          >
            <mat-icon class="navigate-icon">navigate_before</mat-icon>
          </button>
          <button
            mwlCalendarToday
            [(viewDate)]="viewDate"
            class="today-btn quicksand-bold-label"
            aria-label="Example icon button with a home icon"
            (click)="getUpcomingEvents(true)"
          >
            Today
          </button>
          <button
            mwlCalendarNextView
            [view]="calendarViewType"
            [(viewDate)]="viewDate"
            class="navigate-btn two"
            aria-label="Example icon button with a home icon"
            (click)="getUpcomingEvents(true)"
          >
            <mat-icon class="navigate-icon">navigate_next</mat-icon>
          </button>
        </div>

        <label class="quicksand-bold-label label-view-date">
          {{ viewDate | calendarDate : calendarViewType + 'ViewTitle' : 'en' }}
        </label>
      </div>

      <div [ngSwitch]="calendarViewType" class="month-view-calendar-content mt-4">
        <mwl-calendar-month-view
          class="student-dashboard-upcoming-events {{ isExpand ? 'upcoming-event-calendar-content' : '' }}"
          *ngSwitchCase="CalendarView.Month"
          [viewDate]="viewDate"
          [events]="upcomingEvents"
          [refresh]="refresh"
          [activeDayIsOpen]="activeDayIsOpen"
          (dayClicked)="dayClicked($event.day)"
          (beforeViewRender)="beforeMonthViewRender($event)"
        >
        </mwl-calendar-month-view>
      </div>
    </div>

    <div
      class="upcoming-event-info"
      [ngClass]="{
        'col-md-12 mt-3': isStudent,
        'col-md-12 col-lg-12 mt-3': !isStudent,
        'w-100 upcoming-event-info': true,
        'web-view-scrollbar': !storageService.detectMob()
      }"
    >
      <button
        class="add-event quicksand-bold-label float-right text-capitalize text-white mt-2"
        *ngIf="isExpand && !isSuperAdmin && (isAdmin || isTeacher) && !isMobileScreen"
        nbButton
        (click)="openEventModal()"
        title="Add Event"
      >
        <nb-icon icon="plus-outline"></nb-icon>
        Add Event
      </button>

      <div class="d-flex justify-content-between mt-xxl-3 px-xxl-3">
        <div class="w-100">
          <h6 class="mt-xl-2 mt-xxl-2 quicksand-bold-label mb-0 main-content-label">Upcoming Special Events</h6>
          <label class="events-info quicksand-bold-label"> Important Dates and Events: Deadlines, Holidays, and Teacher Activities </label>

          <div *ngIf="isExpand && !isSuperAdmin && (isAdmin || isTeacher) && isMobileScreen" class="d-flex justify-content-end mt-2">
            <button class="add-event quicksand-bold-label text-capitalize text-white mb-2" nbButton (click)="openEventModal()" title="Add Event">
              <nb-icon icon="plus-outline"></nb-icon>
              Add Event
            </button>
          </div>
        </div>

        <div class="mt-xl-2 mt-xxl-2 expand-admin-events-content icon-expand-view expand-view-button" *ngIf="isStudent">
          <nb-icon (click)="expandUpcomingEventsView()" icon="expand" class="icon-expand-pacing-plan cursor-pointer expand-details"></nb-icon>
        </div>
      </div>

      <nb-tabset *ngIf="isTeacher" class="assessment-questions-tab-set-content notes-tab-set-content" (changeTab)="userTabChange($event)">
        <nb-tab tabTitle="All Events">
          <ng-container [ngTemplateOutlet]="TeacherViewContent"></ng-container>
        </nb-tab>
        <nb-tab tabTitle="My Events">
          <ng-container [ngTemplateOutlet]="TeacherViewContent"></ng-container>
        </nb-tab>
      </nb-tabset>

      <div *ngIf="!isTeacher">
        <div
          *ngFor="let event of upcomingEvents; let i = index"
          class="upcoming-events-card-content cursor-pointer pt-2 pl-2 {{ event?.cssClass }} {{ !isSuperAdmin && isAdmin ? 'cursor-pointer' : '' }}"
          (click)="!isSuperAdmin && isAdmin ? openEventModal(event) : null"
        >
          <div class="d-flex">
            <div class="events-date text-center event-date-margin-top">
              <div class="events-date-content {{ isExpand ? 'events-date-exp' : '' }}">
                <label class="event-date-dark quicksand-bold-label">
                  {{ event?.start | date : 'd' }}
                </label>

                <p class="quicksand-bold-label event-start-text p-color-dark-mode">
                  {{ event?.start | date : 'EEE' }}
                </p>
              </div>

              <span class="dot-content"></span>
            </div>

            <div class="main-event ml-3" *ngIf="isMobileScreen">
              <label class="event-date-label quicksand-bold-label">
                <!-- {{ event?.start | date : 'MMM d, y,  h:mm:ss a' }}
                <br /> -->
                {{ event?.end | date : 'MMMM d, y, h:mm a' }}
              </label>
              <br />
              <label class="quicksand-bold-label events-title">{{ event?.title | titlecase }}</label>
            </div>

            <div class="main-event ml-3" *ngIf="!isMobileScreen">
              <label class="event-date-label quicksand-bold-label">
                <!-- {{ event?.start | date : 'MMM d, y,  h:mm:ss a' }} -->
                {{ event?.end | date : 'MMMM d, y, h:mm a' }}
              </label>
              <br />
              <label class="quicksand-bold-label events-title">{{ event?.title | titlecase }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="quicksand-bold-label pt-4 text-center" *ngIf="upcomingEvents && upcomingEvents.length === 0">
        <img src="/assets/images/respond-edu.svg" alt="no-events-found" height="100" width="100" />
        <br />
        No Events Found for Current Month!
      </div>
    </div>

    <br />
  </div>
</div>

<ng-template #viewEventModal>
  <div class="overlay-modal-content rounded-radius" tabindex="-1" role="dialog">
    <div
      class="modal-content view-lesson-plan-modal add-extra-event lesson-plan-modal add-classroom-modal add-event-modal border-0"
      [ngClass]="{
        'dark-theme': analyticsService?.currentTheme === 'material-dark'
      }"
    >
      <div class="modal-header d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
          <span class="icon-add-classroom">
            <nb-icon icon="plus-outline"></nb-icon>
          </span>
          <h6
            class="quicksand-bold-label add-event-label m-0"
            *ngIf="!currentValuesToPass?.adminEvent || currentValuesToPass?.adminEvent?.user_id === currentValuesToPass?.user?.user?.id"
          >
            <span *ngIf="!isEditEvent">Add</span>
            <span *ngIf="isEditEvent">Update</span> Event
          </h6>

          <h6
            class="quicksand-bold-label add-event-label m-0"
            *ngIf="currentValuesToPass?.adminEvent && currentValuesToPass?.adminEvent?.user_id !== currentValuesToPass?.user?.user?.id"
          >
            <span>View Event</span>
          </h6>
        </div>

        <span
          class="icon-close-classroom-modal d-block cursor-pointer"
          (click)="closeDialog(); analyticsService?.trackEvent('Admin School Modal', 'Admin School Events')"
        >
          <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
        </span>
      </div>
      <ng-container *ngIf="isOpenModal" [ngTemplateOutlet]="eventForm"></ng-container>
    </div>
  </div>
</ng-template>

<!-- week event template -->
<ng-template #eventTemplate let-weekEvent="weekEvent" let-locale="locale">
  <div class="week-event-content">
    <div class="row p-1">
      <div class="col-md-12">
        <label class="event-label">Title :</label>
        <div class="event-section event-body">
          {{ weekEvent.event.title }}
        </div>
      </div>

      <div class="col-md-12">
        <label class="event-label">Time :</label>
        <div class="event-section event-body">
          {{ weekEvent.event.start | date : 'h:mm a' }} -
          {{ weekEvent.event.end | date : 'h:mm a' }}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #eventForm>
  <ngx-admin-event-forms
    [values]="currentValuesToPass"
    (submitForm)="submitFormValues($event)"
    [isTeacher]="isTeacher"
    [schoolEndDate]="endDate"
  ></ngx-admin-event-forms>
</ng-template>

<ng-template #TeacherViewContent>
  <div
    *ngFor="let event of upcomingEvents; let i = index"
    class="upcoming-events-card-content cursor-pointer pt-2 pl-2 {{ event?.cssClass }} {{ !isSuperAdmin && isTeacher ? 'cursor-pointer' : '' }}"
    (click)="!isSuperAdmin && isTeacher ? openEventModal(event) : null"
  >
    <div class="d-flex">
      <!-- <div class="events-date text-center event-date-margin-top">
        <div class="events-date-content {{ isExpand ? 'events-date-exp' : '' }}">
          <label class="event-date-dark quicksand-bold-label">
            {{ event?.start | date : 'd' }}
          </label>

          <p class="quicksand-bold-label event-start-text p-color-dark-mode">
            {{ event?.start | date : 'EEE' }}
          </p>
        </div>

        <span class="dot-content"></span>
      </div> -->

      <div class="main-event ml-3" *ngIf="isMobileScreen">
        <label class="event-date-label quicksand-bold-label">
          <!-- {{ event?.start | date : 'MMM d, y,  h:mm:ss a' }} -->
          <br />
          {{ event?.end | date : 'MMMM d, y, h:mm a' }}
        </label>
        <br />
        <label class="quicksand-bold-label events-title">{{ event?.title | titlecase }}</label>
      </div>

      <div class="main-event ml-3" *ngIf="!isMobileScreen">
        <label class="event-date-label quicksand-bold-label">
          <!-- {{ event?.start | date : 'MMM d, y,  h:mm:ss a' }} -->
          {{ event?.end | date : 'MMMM d, y, h:mm a' }}
        </label>
        <br />
        <label class="quicksand-bold-label events-title">{{ event?.title | titlecase }}</label>
      </div>
    </div>
  </div>
</ng-template>
